import React from 'react';
import ContentLoader from 'react-content-loader';

const ContentPlaceholder = props => (
  <ContentLoader width={616} height={460} speed={3} primaryColor="#ebecef" secondaryColor="#d1d2db" {...props}>
    <rect x="32" y="32" rx="4" ry="4" width="128" height="8" />
    <rect x="32" y="48" rx="4" ry="4" width="208" height="24" />
    <rect x="32" y="88" rx="4" ry="4" width="144" height="8" />
    <rect x="32" y="120" rx="10" ry="10" width="80" height="20" />
    <rect x="128" y="120" rx="10" ry="10" width="80" height="20" />
  </ContentLoader>
);

export default ContentPlaceholder;



// WEBPACK FOOTER //
// ./src/components/ui/layout/spinner/content-placeholder.jsx